function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "noun_Share_844668",
  d: "M5.425,33.382a.7.7,0,0,0,.758-.14,19.243,19.243,0,0,1,12.776-5.375V32.74a.7.7,0,0,0,1.191.494l9.771-9.771a.7.7,0,0,0,0-.987L20.15,12.7a.7.7,0,0,0-1.191.493v4.9A14.674,14.674,0,0,0,5,32.74.7.7,0,0,0,5.425,33.382Zm14.231-13.9a.7.7,0,0,0,.7-.7v-3.9l8.086,8.086-8.086,8.086v-3.9a.7.7,0,0,0-.7-.7A20.71,20.71,0,0,0,6.5,31.1,13.28,13.28,0,0,1,19.657,19.479Z",
  transform: "translate(-4.875 -12.364)",
  fill: "#25a4b4",
  stroke: "#25a3b4",
  strokeWidth: 0.25
});

var SvgIconInvite = function SvgIconInvite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.375,
    height: 21.21,
    viewBox: "0 0 25.375 21.21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconInvite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-invite.91ff55e9.svg";
export { ForwardRef as ReactComponent };